import { render, staticRenderFns } from "./LiquidacionesHome.vue?vue&type=template&id=475fb2c2&scoped=true&"
import script from "./LiquidacionesHome.vue?vue&type=script&lang=js&"
export * from "./LiquidacionesHome.vue?vue&type=script&lang=js&"
import style0 from "./LiquidacionesHome.vue?vue&type=style&index=0&id=475fb2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475fb2c2",
  null
  
)

export default component.exports